import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CountdownModule } from '@modules/countdown/countdown.module';
import { MediaModule } from '@modules/media/media.module';
import { PipesModule } from '@modules/pipes/pipes.module';
import { SharedModule } from '@modules/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { UiModule } from '../ui/ui.module';

import { ContactCardComponent } from './contact-card/contact-card.component';
import { EventCardComponent } from './event-card/event-card.component';
import { MediaCardComponent } from './media-card/media-card.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    TranslateModule,
    PipesModule,
    UiModule,
    MediaModule,
    CountdownModule,
  ],
  declarations: [MediaCardComponent, ContactCardComponent, EventCardComponent],
  exports: [MediaCardComponent, ContactCardComponent, EventCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardsModule {}
